// Loader.js
import React, { useEffect, useState } from "react";
import logo from "../img/HBrowLogo.gif";

const Loader = ({ onLoaded }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
      onLoaded(); // Pozivaj funkciju kada se učitavanje završi
    }, 2000); // Postavi vreme trajanja učitavanja (3 sekunde)

    return () => clearTimeout(timer); // Očisti timer kada se komponenta unmountuje
  }, [onLoaded]);

  return (
    <div className={`loader ${loading ? "active" : ""}`}>
      <img src={logo} alt="Puder obrve - Heli Brows Logo" />
    </div>
  );
};

export default Loader;
